import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { getExpenses, ExpenseListParams } from 'services/expense.service';

export const getExpensesQueryKey = 'getExpenses';

export const useExpenses = (params?: ExpenseListParams) => useQuery(
  [getExpensesQueryKey, params],
  () => getExpenses(params).then((r: AxiosResponse) => r.data),
  { refetchOnWindowFocus: false, retry: false },
);
